import * as angular from "angular";
import {Link} from "../models/link.model";
import {Group} from "../models/groups/group.model";
import {GroupsService} from "../common/groups/groups.service";
import {StudyProgram} from "../models/study-program.model";
import {Instructor} from "../models/instructor.model";
import {GroupProperties} from "../models/groups/group-properties.model";
import {UserSessionService} from "../common/user-session/user-session.service";
import {TestprepRootScope} from "../models/testprep-rootscope.model";
import {MessagingService} from "../common/messaging/messaging.service";
import {TypeaheadProviderService} from "../common/typeahead-provider/typeahead-provider.service";

const SUCCESS_ONE_KEY = "successMessageOne";
const SUCCESS_MULTIPLE_KEY = "successMessageMultiple";
const MESSAGE_KEY = "assignedPrograms";

interface AssignRouteLocals {
    groups: Group[];
    studyPrograms: StudyProgram[];
    instructors: Instructor[];
    [index: string]: any;
    $scope: angular.IScope;
    $template: string;
}
  interface AssignTypes { 
    assignGroups: Group[];
    assignPrograms: StudyProgram[]; 
    assignInstructors: Instructor[];
};
type typeaheadSource = Group | Instructor | StudyProgram;


export class AssignProgramsController {
    crumbs: Link[];
    tenantId: string;
    studyPrograms: StudyProgram[];
    assignPrograms: StudyProgram[] = [];
    groups: Group[];
    assignGroups: Group[] = [];
    instructors: Instructor[];
    tagType: typeaheadSource[];
    assignInstructors: Instructor[] = [];
    programTypeaheadPaths: string[] = ["courseSlug", "courseTitle"];
    groupTypeaheadPaths: string[] = ["groupName", "groupCode"];
    instructorTypeaheadPaths: string[] = ["name.firstName", "name.lastName", "name.displayName"];
    assignmentTypes: AssignTypes = {
        assignGroups: this.assignGroups, 
        assignInstructors: this.assignInstructors, 
        assignPrograms: this.assignPrograms
    };

    /* @ngInject */
    constructor (
        private $route: angular.route.IRouteService, 
        private groupsService: GroupsService,
        private $location: angular.ILocationService, 
        private userSessionService: UserSessionService,
        private $rootScope: TestprepRootScope, 
        private messagingService: MessagingService,
        private typeaheadProviderService: TypeaheadProviderService
    ) {}

    $onInit(): void {
        let locals = <AssignRouteLocals>this.$route.current.locals;
        this.tenantId = this.$route.current.params.tenantId;
        this.groups = locals.groups;
        this.studyPrograms = locals.studyPrograms;
        this.instructors = locals.instructors;
        this.updateCrumbs();
    }

    submitReady(): boolean {
        return !!this.assignPrograms.length && !!this.assignGroups.length && !!this.assignInstructors.length;
    }

    submit(): void {
        this.clearError();
        this.$rootScope.loadingView = true;
        let properties: GroupProperties = {
            instructors: this.assignInstructors,
            studyPrograms: this.assignPrograms,
            groups: this.assignGroups
        };
        this.groupsService.assignGroups(this.tenantId, properties)
            .then(this.handleResponse, this.errorCallback);
    }
    handleAdd = (tag: any, type: string): void => {
     this.tagType = this.typeaheadProviderService.setTagType(type, this.assignmentTypes);
      this.tagType.push(tag);
    };
    handleRemove = (tag: any, type: string): void => {
        this.tagType = this.typeaheadProviderService.setTagType(type, this.assignmentTypes);
        this.tagType.splice(this.tagType.indexOf(tag), 1);
    };

    clearError(): void { this.$rootScope.loadingError = false; }

    errorCallback = (): void => {
        this.$rootScope.loadingError = true;
        this.$rootScope.loadingView = false;
    };

    goHome = (): void => {
        if (this.userSessionService.isDistrictMode()) {
            this.$location.path(`/${this.userSessionService.getDistrictTenantId()}`);
        } else {
            this.$location.path(`/${this.tenantId}`);
        }
    };

    typeaheadProvider = (input: string, typeaheadSource: any, tags: string[], typeaheadPaths: string[]): any => {
        return this.typeaheadProviderService.typeaheadProvider(input, typeaheadSource, tags, typeaheadPaths);
    };

    private handleResponse = (status: number): void => {
        if (status < 400) {
            if (this.assignGroups.length === 1) {
                this.$rootScope.successMessage = `${this.assignGroups.length} ${this.messagingService(MESSAGE_KEY)[SUCCESS_ONE_KEY]}`;
            } else {
                this.$rootScope.successMessage = `${this.assignGroups.length} ${this.messagingService(MESSAGE_KEY)[SUCCESS_MULTIPLE_KEY]}`;
            }
            this.goHome();
        } else {
            this.errorCallback();
        }
    };

    private updateCrumbs() {
        if (this.userSessionService.isDistrictMode()) {
            this.crumbs = [
                {
                    name: "Naviance Test Prep: District",
                    url: `${this.userSessionService.getDistrictTenantId()}`
                },
                {
                    name: `${this.userSessionService.getCurrentSchool().name}`,
                    url: `${this.userSessionService.getDistrictTenantId()}`
                },
                {
                    name: "Assign Study Programs"
                }
            ];
        } else {
            this.crumbs = [
                {
                    name: "Naviance Test Prep",
                    url: `${this.tenantId}`
                }, {
                    name: "Assign Study Programs"
                }
            ];
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/assign-programs/assign-programs.controller.ts
 **/